export const EXACT = 'EXACT';
export const RECURRING = 'RECURRING';
export const DEPENDENT_ON_PREVIOUS_TASK = 'DEPENDENT_ON_PREVIOUS_TASK';

